import React, { Component } from "react";
import ConteudoAvaliacao from "./ConteudoAvaliacao";
import Controlos from "../../components/Controlos.jsx";
import ControlosSimples from "../../components/ControlosSimples.jsx";
import LazyLoad from "react-lazy-load";
import Oops from "../../../../pages/Oops.jsx";

import { iconAvaliacao } from "../../../../assets/tipoDeConteudos";

class Avaliacao extends Component {
    state = {
        nome: "",
        objetivos: "",
        questoes: 0,
        dataHora: "",
        //NAO DISPONIVEL
        nao_disponivel: false,
        sameUrl: true
    };

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState(
                {
                    sameUrl: false
                },
                () =>
                    this.setState({
                        sameUrl: true
                    })
            );
        }
    }

    marcarComoNaoDisponivel = () => {
        this.setState({
            nao_disponivel: true
        });
    };

    render() {
        const {
            nome,
            objetivos,
            questoes,
            dataHora,
            //NAO DISPONIVEL
            nao_disponivel,
            sameUrl
        } = this.state;

        return (
            <div className="questionario">
                <div className="player-wrapper">
                    {!nao_disponivel ? (
                        <>
                            <ConteudoAvaliacao
                                marcarComoNaoDisponivel={this.marcarComoNaoDisponivel}
                                carregarInfo={(nome, objetivos, questoes, dataHora) =>
                                    this.setState({ nome, objetivos, questoes, dataHora })
                                }
                            />
                            <Controlos
                                backUrl={
                                    localStorage.getItem("player_back_url")
                                        ? localStorage.getItem("player_back_url")
                                        : `/gerir-detalhe-turma/${this.props.match.params.curso.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/modulos`
                                }
                                sameUrl={sameUrl}
                                temAnotacoes
                                temInformacoes
                                nome={nome}
                                objetivos={objetivos}
                                questoes={questoes}
                                icon={iconAvaliacao}
                                dataHora={dataHora}
                            />
                        </>
                    ) : (
                        <>
                            <div className="container">
                                <div className="bloco-nao-disponivel">
                                    <div className="bloco-info nao-disponivel">
                                        <Oops tem_texto texto={"Conteúdo não disponível"} />
                                    </div>
                                </div>
                            </div>
                            <ControlosSimples />
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default Avaliacao;
